import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShift: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shift"><path d="M13.2507 2.45765C12.5641 1.75516 11.434 1.75516 10.7475 2.45765L2.37301 11.0269C1.29008 12.135 2.07519 14 3.62459 14H6.1175V17.25C6.1175 19.3211 7.79644 21 9.8675 21H14.1307C16.2017 21 17.8807 19.3211 17.8807 17.25V14H20.3736C21.923 14 22.7081 12.135 21.6252 11.0269L13.2507 2.45765Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShift;
